// 监考相关的vuex数据
export default {
  state: {
    streamObj: null,     // 当前视频对象
    connectClient: null,  // 连线对象
    connectStream: null,  // 连线音频流
    violationCount: null,   // 违规人数
    connectObj: null,    // 语音连线对象
    isStopAudio: false,  // 是否停止考试中的音频
    imGroupId: null,    // 直播群Id
    joinGroupSuccess: false,  // 加入直播群成功
    needMonitor: true,  // 是否需要监考
    equipmentMobile: null,   // 设备调试手机是否已连接
    cameraExamId: null, // 当前视频流所属的考试
    screenExamId: null, // 当前屏幕流所属的考试
    cameraClient: null, // 视频客户端
    cameraStream: null, // 视频流
    timerCamera: null,  // 视频流截图定时器
    screenClient: null, // 共享屏幕客户端
    screenStream: null, // 共享屏幕流
    timerScreenImg: null, // 共享屏幕截图定时器
    screenFormExamId: '', // 共享屏幕归属于哪个考试
    mobileContinue: null, // 手机监考是否已连接
    imMessageList: null,    // 登录后获取到的im消息
    timerErrorCamera: null, // 每分钟检测一次摄像头的弹框
    examCameraId: null,      // 摄像头归属那个考试
    noCameraTips: true,     // 需要摄像头提示
    isConnecting: false,      // 共享屏幕是否正在连接中
    nowTestStatus: null,         // 当前考试状态
    cameraPublishState: false,           // 摄像头推流状态
    micPhonePublishState: false,           // 麦克风推流状态
    screenPublishState: false,           // 共享屏幕推流状态
    imNeedReconnect: false           // 是否需要重连im
  },
  mutations: {
    set_imNeedReconnect (state, val) {
      state.imNeedReconnect = val
    },
    set_cameraPublishState (state, val) {
      state.cameraPublishState = val
    },
    set_micPhonePublishState (state, val) {
      state.micPhonePublishState = val
    },
    set_screenPublishState (state, val) {
      state.screenPublishState = val
    },
    set_streamObj (state, val) {
      state.streamObj = val
    },
    set_nowTestStatus (state, val) {
      state.nowTestStatus = val
    },
    set_isStopAudio (state, val) {
      state.isStopAudio = val
    },
    set_connectClient (state, val) {
      state.connectClient = val
    },
    set_connectStream (state, val) {
      state.connectStream = val
    },
    set_violationCount (state, val) {
      state.violationCount = val
    },
    set_connectObj (state, val) {
      state.connectObj = val
    },
    set_isConnecting (state, val) {
      state.isConnecting = val
    },
    set_equipmentMobile (state, val) {
      state.equipmentMobile = val
    },
    set_noCameraTips (state, val) {
      state.noCameraTips = val
    },
    set_needMonitor (state, val) {
      state.needMonitor = val
    },
    set_joinGroupSuccess (state, val) {
      state.joinGroupSuccess = val
    },
    set_imGroupId (state, val) {
      state.imGroupId = val
    },
    set_cameraClient (state, val) {
      state.cameraClient = val
    },
    set_cameraStream (state, val) {
      state.cameraStream = val
    },
    set_screenClient (state, val) {
      state.screenClient = val
    },
    set_screenStream (state, val) {
      state.screenStream = val
    },
    set_mobileContinue (state, val) {
      state.mobileContinue = val
    },
    set_cameraExamId (state, val) {
      state.cameraExamId = val
    },
    set_screenExamId (state, val) {
      state.screenExamId = val
    },
    set_imMessageList (state, val) {
      state.imMessageList = val
    },
    set_screenFormExamId (state, val) {
      state.screenFormExamId = val
    },
    set_timerScreenImg (state, val) {
      state.timerScreenImg = val
    },
    set_timerCamera (state, val) {
      state.timerCamera = val
    },
    set_timerErrorCamera (state, val) {
      state.timerErrorCamera = val
    },
    set_examCameraId (state, val) {
      state.examCameraId = val
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/proctor.js